<template>
  <div class="c-health-projects">
    <div class="ms-row c-solidarity-content">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0012_psychodon.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>支持Psychodon协会，对抗精神疾病</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>PSYCHODON</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>多年来，基金会大力资助Psychodon协会的各项计划。该协会的创立宗旨，是将精神健康领域的协会、受益者、赞助商及企业联系起来，使各方参与者能够互相合作。为此，Psychodon协会每年都会举办一场大型活动，以增加公众对精神疾病的了解，减少其污名化，并为病患及其看护人筹集善款。每年的6月12日，Psychodon都会在Olympia举办这项活动。该活动获得了法国总统Emmanuel Macron的支持，并与Fondation de France合作举办。</p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="https://psychodon.org/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0011_clubhouse.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>支持Clubhouse收容心理障碍或精神疾病患者</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>CLUBHOUSE</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>2014年起，基金会开始向Clubhouse提供帮助。这是一个非医疗日托机构，专向患有精神或心理障碍的人士开放。最初，基金会在位于巴黎十九区的总部，创建了一个专门用于培训和就业的互助空间。随后，基金会帮助该机构在全法国推广该项目，并共同发起了一项帮助精神病患者就业的行动计划。该计划通过三大层面落实：重获自信、确认职业项目、与巴黎Clubhouse合作以共同维持就业。</p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://www.clubhousefrance.org/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0010_fondation-jerome-lejeune.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>支持对抗遗传性疾病研究</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>JÉRÔME LEJEUNE基金会</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>Jérôme Lejeune教授既是一位医生，又是一名科研人员。1959年，他在Marthe Gautier的帮助下，发现了唐氏综合症的成因。Jérôme Lejeune基金会致力于造福智力障碍者及其家属，始终以三大目标为宗旨：科研、护理和倡导。该基金会推出并支持了多个科研项目，以推动和改善唐氏综合症及其他遗传性智力障碍的治疗方式。基金会每年都会为一名从事遗传疾病治疗方案的研究人员提供资金奖励。此外，基金会还会向病人家属及大众推广与此相关的护理信息和当前的研究进展，并以此为基础收集新的科研资源。</p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="https://www.fondationlejeune.org/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0009_pitie-salpetriere.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>以最佳環境接待年輕病患者</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>PITIÉ-SALPÊTRIÈRE醫院</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            Sisley多納諾基金會支持Pitié-Salpêtrière醫院的兒童與青少年精神科診療室和接待大廳的整修與翻新。
            這些往往令人不適的空間在整修後變得更友善、更符合人體工學和更舒適，讓醫院在接待年輕患者及其家屬時更為人性化，同時提升接待的品質。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://pitiesalpetriere.aphp.fr/devenez-donateur-mecene/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0008_belle-et-bien.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>支持「Belle et Bien」网络，为患癌女性提供护理服务</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>「BELLE & BIEN」</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>基金会与美容业界其他品牌连手，通过支持「Belle & Bien」网络为医院内的病患提供美容护理。自2002年起，「Look Good Feel Better」国际网络的法国分部在医院内组织了多次免费的护肤和彩妆活动。「Belle & Bien」机构旨在帮助接受癌症治疗的女性重拾自信风采。在两个小时的课程中，志愿者协调员和美容师为参与者提供各类美容和护肤护理。此外，她们还能学会怎样护理肌肤，让因经历癌症治疗而变得黯沉不适的肌肤重新变得水润舒适。随后，她们将学习如何借助彩妆来重塑眉形、提亮眼眸、让肤色重绽光彩。</p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://www.bellebien.fr/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0007_reseau-profamille.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>支持Profamille计划，共同应对精神分裂症</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>PROFAMILLE网络</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>基金会通过支持Profamille计划的发展来为精神分裂症病患的家属提供支持。在法国，共有1%的人口患有精神分裂症。当患者被诊断出疾病时，家属通常会感到不知所措，心中留下无数疑团，这些态度可能会对他们陪伴的家人产生负面影响。Profamille通过提供长达几个月的课程，帮助参与者们获得相关培训，以便更好地理解这种疾病和精神治疗法，从而能够用更正确的态度来与患者和睦相处。这种疗法培训于1987年在魁北克问世，其效果已经过验证，可为病患及其家属带来绝对的正向帮助。如今，共有70多个团队在法语系国家提供这项服务。</p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://www.fondationpierredeniker.org/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0006_institut-montaigne.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>为FondaMental基金会的预防自杀研究项目提供支持</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>FONDAMENTAL基金会</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>FondaMental基金会是一家以对抗精神疾病为宗旨的研究基金会，将护理与尖端科研相结合，以推广专门面向严重精神疾病患者的个性化多学科管理。法国Besançon 大学医院成人精神病学部门的Djamila Bennabi博士所开展的研究项目便获得了基金会的支持。该项目旨在研究一种有效的治疗策略，以减少重度抑郁症患者的自杀冲动，从而达到降低自杀风险的目的。</p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://www2.josephinebeaute.fr/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0005_les-amis-de-latelier.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>隨著智能障礙與精神疾病患者病程的需求而應變</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>工作坊之友基金會</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            「聯盟」（Alliance）是工作坊之友基金會（Fondation des Amis de
            l’Atelier）的所在地，該基金會於1996年在弗爾里埃勒比伊松（Verrières-Le-Buisson，91省）成立，接待約40名智能障礙與精神疾病患者。
            建築空間的侷限成為使各具不同需求的兩個世代融洽共處的障礙，因此必需進行擴建工程，以使機構現代化。
            Sisley多納諾基金會資助「聯盟之家」（Foyer
            l'Alliance）的烹飪課程計劃，並建立家庭聚室，這兩項翻修計劃使住宿者倍感舒適，並和寄宿的家庭維持緊密的關係。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="https://www.fondation-amisdelatelier.org/nos-projets/extension-foyer-alliance/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0004_elisabeth-dornano.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>支特Elisabeth d'Ornano协会，帮助对抗儿童和青少年的专注力不足和多动症</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>ELISABETH D'ORNANO协会</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>这家西班牙协会由Elisabeth d'Ornano创办，多年来一直获得基金会的大力支持。在精神病专家的帮助下，协会开发出一系列课程，以便为家长、教师和儿科医生提供关于儿童、青少年专注力不足及多动症相关的讯息，以及有效应对此类精神障碍的方法。协会的网站以三种语言推出这些课程，此外，还有在学校内开展的研讨会及各类培训。</p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://www.elisabethornano-tdah.org/fr/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0003_debra-france.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>對抗表皮分解性水皰症（俗稱泡泡龍症）</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>DEBRA France</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            Sisley多納諾基金會支持由法國350多個表皮分解性水皰症患者家庭所組成的Debra
            France協會。
            這種罕見遺傳病使皮膚像蝴蝶的表皮一樣脆弱，皮膚會在外力作用下自行剝落，導致類似水泡的傷口。
            這種罕見遺傳病至今仍無法治癒，導致患者嚴重的生理障礙，而且極為疼痛。
            該協會的主要目標是藉助「黛柏拉國際」（Debra
            International）網絡，而代表、陪伴和支持患者及其家屬，並推廣這種疾病的知識、資助研究、聯繫所有相關人士，並在本地協調全球性的活動。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://www.debra.fr/faire-un-don-a-lassociation-debra-france/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0002_les-funambules.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>陪伴面臨精神疾病的家庭</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>走索人協會</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            Sisley多納諾基金會支持「走索人」（Les
            Funambules）協會，該協會旨在關注家中有成員罹患精神疾病的7到25歲年輕人的處境。該協會針對精神分裂症、躁鬱症或憂鬱症患者的小孩及兄弟姐妹。
            該協會成立於2018年，逐步為患者周圍年輕人提供合適的支持，並依照他們的年齡，適切回應他們關於精神障礙的疑問。
            該協會也提供喚起專業人士意識的模範。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://www.associationlesfunambules.com/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0001_association-syndrome-de-barth.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>資助罕見疾病研究</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>巴氏症候群協會</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            「巴氏症候群」（Syndrome de
            Barth）協會旨在對病患者家屬及醫生提供資訊和喚起意識，並研究可能致命的嚴重遺傳疾病─
            ─巴氏症候群的療法，藉此盡力挽救生命。
            Sisley多納諾基金會資助一項尋求巴氏症候群治療方法的研究計劃。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://www.syndromedebarth.fr/">了解更多</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { name: "FoundationHealth" };
</script>

<style lang="scss" scoped>
  .c-solidarity-content {
    padding-bottom: 4.8125rem;
    .c-solidarity-content__title-primary {
      font-size:.75rem;line-height:1.67;color:#000;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;padding-top:2.1875rem;
      p { margin-bottom:.3125rem; }
    }
    .c-solidarity-content__title-secondary {font-size:1.25rem;color:#000;font-family:PlayfairDisplay-Italic,arial,sans-serif;}
    .c-solidarity-content__description {font-size:.8125rem;line-height:1.62;color:#000;font-family:HelveticaNeueLTW05-35Thin,arial,sans-serif;}
    .m-foundation-content__projects-title--third {z-index:2;font-weight:700;font-size:.75rem;text-decoration:underline;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;top:.625rem;}
    .m-minisite__description a { display: none; }
  }
  @media screen and (min-width:48em) {
    .c-solidarity-content { padding-bottom: 6.0625rem; }
  }
  @media screen and (min-width:64em) {
    .c-solidarity-content {
      padding-bottom: 8rem;
      .c-solidarity-content__title-primary { padding-top: 0; }
    }
  }
</style>